import React from 'react';
import { StyledIsFetchingIndicator, Spinner } from './IsFetchingIndicatorStyles';

interface Props {
  text?: string;
}

export const IsFetchingIndicator: React.FC<Props> = ({ text = 'Updating...', ...other }) => {
  return (
    <StyledIsFetchingIndicator {...other}>
      <Spinner />
      {text}
    </StyledIsFetchingIndicator>
  );
};
